
const ActionTypes = {
  CREATE_GENERAL_CONTENT: "CREATE_GENERAL_CONTENT",
  ON_MEDIA_UPLOAD: "ON_MEDIA_UPLOAD",
  UPLOAD_VIDEO: "UPLOAD_VIDEO",
  UPLOAD_TRAILER: "UPLOAD_TRAILER",
  ADD_AUDIO_TRACKS: "ADD_AUDIO_TRACKS",
  ADD_SUBTITLES: "ADD_SUBTITLES",
  GET_CATEGORY: "GET_CATEGORY",
  ADD_CREW_MEMBERS: "ADD_CREW_MEMBERS",
  UPDATE_GENERAL_CONTENT: "UPDATE_GENERAL_CONTENT",
  REUPLOAD_VIDEO: "REUPLOAD_VIDEO",
  REUPLOAD_TRAILER: "REUPLOAD_TRAILER",
  UPDATE_AUDIO_TRACKS: "UPDATE_AUDIO_TRACKS",
  UPDATE_SUBTITLES: "UPDATE_SUBTITLES",
  UPDATE_CREW_MEMBERS: "UPDATE_CREW_MEMBERS",
  DELETE_GENERAL_CONTENT: "DELETE_GENERAL_CONTENT",
  DELETE_VIDEO: "DELETE_VIDEO",
  DELETE_TRAILER: "DELETE_TRAILER",
  DELETE_AUDIO_TRACKS: "DELETE_AUDIO_TRACKS",
  DELETE_SUBTITLES: "DELETE_SUBTITLES",
  DELETE_CREW_MEMBERS: "DELETE_CREW_MEMBERS",

  // edit movie general content
  UPDATE_GENERAL_CONTENT_MOVIE: "UPDATE_GENERAL_CONTENT_MOVIE",

  // video
  CREATE_VIDEO_GENERAL_CONTENT: "CREATE_VIDEO_GENERAL_CONTENT",
  UPDATE_GENERAL_CONTENT_VIDEO: "UPDATE_GENERAL_CONTENT_VIDEO",
  ON_VIDEO_MEDIA_UPLOAD: "ON_VIDEO_MEDIA_UPLOAD",

  // SHOW
  CREATE_SHOW_GENERAL_CONTENT: "CREATE_SHOW_GENERAL_CONTENT",
  SEASON_LIST: "SEASON_LIST",
  EPISODE_LIST: "EPISODE_LIST",
  UPDATE_GENERAL_CONTENT_SHOW: "UPDATE_GENERAL_CONTENT_SHOW",
  // seasons
  CREATE_SEASON_GENERAL_CONTENT: "CREATE_SEASON_GENERAL_CONTENT",
  // EPISODES
  CREATE_EPISODE_GENERAL_CONTENT: "CREATE_EPISODE_GENERAL_CONTENT",
  ON_EPISODE_MEDIA_UPLOAD: "ON_EPISODE_MEDIA_UPLOAD",
  UPLOAD_TRAILER_SHOW: "UPLOAD_TRAILER_SHOW",
  UPDATE_GENERAL_CONTENT_EPISODE: "UPDATE_GENERAL_CONTENT_EPISODE",
  // FOR EPISODE INFO PAGE
  GET_GENERAL_CONTENT_EPISODE_INFO: "GET_GENERAL_CONTENT_EPISODE_INFO",

  // podcast
  CREATE_PODCAST_GENERAL_CONTENT: "CREATE_PODCAST_GENERAL_CONTENT",
  UPDATE_GENERAL_CONTENT_PODCAST: "UPDATE_GENERAL_CONTENT_PODCAST",
  UPLOAD_TRAILER_PODCAST: "UPLOAD_TRAILER_PODCAST",
  CREATE_PODCAST_EPISODE_GENERAL_CONTENT:
    "CREATE_PODCAST_EPISODE_GENERAL_CONTENT",
  UPDATE_GENERAL_CONTENT_PODCAST_EPISODE:
    "UPDATE_GENERAL_CONTENT_PODCAST_EPISODE,",
  GET_GENERAL_CONTENT_PODCAST_EPISODE_INFO:
    "GET_GENERAL_CONTENT_PODCAST_EPISODE_INFO",
  ON_PODCAST_EPISODE_MEDIA_UPLOAD: "ON_PODCAST_EPISODE_MEDIA_UPLOAD",
  CREATE_PODCAST_SEASON_GENERAL_CONTENT:
    "CREATE_PODCAST_SEASON_GENERAL_CONTENT,",
  CREATE_CHANNEL_GENERAL_CONTENT: "CREATE_CHANNEL_GENERAL_CONTENT",
  UPDATE_GENERAL_CONTENT_CHANNEL: "UPDATE_GENERAL_CONTENT_CHANNEL",
  USER_INFO: "USER_INFO",
  CREATE_ADMIN: "CREATE_ADMIN",
  UPDATE_ADMIN_INFO: "UPDATE_ADMIN_INFO",
  BROADCAST_INFO: "BROADCAST_INFO",
  UPDATE_FAQ: "UPDATE_FAQ",
};

export default ActionTypes;
